import Consts from 'Framework/Consts';
import { HttpGetService, IHttpGetServiceProps } from 'Shared/HttpServices/Services/HttpGetService';
import { HttpPostService, IHttpPostServiceProps } from 'Shared/HttpServices/Services/HttpPostService';
import { createAxiosHttpConfig } from 'Shared/HttpServices/Utils/utils';

const KhodroHttpConfig = createAxiosHttpConfig({ baseURL: Consts.env.REACT_APP_KHODRO_APP_BASE_URL });

export const KhodroHttpGetService = async (props: IHttpGetServiceProps) =>
  HttpGetService({
    API: KhodroHttpConfig,
    url: props.url,
    responseType: props.responseType,
    onResult: props.onResult,
    onError: props.onError,
    isFile: props.isFile,
    params: props.params,
  });

export const KhodroHttpPostService = async (props: IHttpPostServiceProps) =>
  HttpPostService({
    API: KhodroHttpConfig,
    url: props.url,
    body: props.body,
    onResult: props.onResult,
    onError: props.onError,
  });
